<!-- @format -->

<ng-container *transloco="let t">
  @if (this.invalidModulesSorted) {
    <div>
      <fudis-notification [variant]="'danger'" [class]="'fudis-mb-sm'">
        <fudis-body-text>
          {{ t("PLAN.STATE.INVALID_SELECTIONS_IN_PLAN") }}
        </fudis-body-text>
        <ul>
          @for (item of this.invalidModulesSorted; track item) {
            <li class="fudis-mt-xxs">
              <a
                fudisLink
                [title]="t(item.title, { name: item.name })"
                [size]="'md'"
                [href]="'#'"
                (click)="handleFocusClick($event, item.focusId)"></a>
            </li>
          }
        </ul>
      </fudis-notification>
    </div>
  }
</ng-container>
